<template>
    <div class="gift-vouchers-payment bg-white  w-100 p-4">
        <div class="col-24  g-0">
            <div class="iframe-payment" v-if="paymentSession">
                <iframe v-if="loaded"

                        v-bind:src="iframeUrl"
                        frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import { getApiEndpoint } from '../../shared/api/utilities';
    import { store } from '../store/index';

    export default {
        name: 'PaymentForm',
        props: {
            paymentSession: {
                type: Object,
                required: true
            },
            sessionId: String
        },
        data() {
            return {
                loaded: false,
                iframe: {
                    wrapperStyle: null,
                }
            }
        },
        mounted() {
            this.loaded = true;
        },
        computed: {
            session() {
                return store.getters.session
            },
            iframeUrl() {
                var encodedData = btoa(this.paymentSession.iPageSessionId);
                return getApiEndpoint() + 'paymentIframe.aspx?iPageSessionId=' + encodedData + '&sessionId=' + this.sessionId;
                //return "http://local.rh.api/paymentIframe.aspx?iPageSessionId=" + encodedData + "&sessionId=" + this.sessionId;
                //return "https://c2c-rockliffe-hall-api-development.azurewebsites.net/paymentIframe.aspx?iPageSessionId=" + encodedData + "&sessionId=" + this.sessionId;
            }
        }
    }
</script>

<style scoped>
    .iframe-payment {
        margin: 0 auto;
        width: 100%;
        height: 550px;
    }

        .iframe-payment iframe {
            width: 100%;
            height: 100%;
        }
</style>